import {
  DEFAULT_STORY_CHARACTER_BOOSTS,
  STORY_BOOST_STAT_KEYS,
} from "./storyState";
import {
  buildStoryCreatureBattleCharacter,
  getStoryCreatureCard,
  STORY_CREATURE_SOURCE,
} from "./storyCreatures";
import {
  resolveStoryTeammateCatalogCharacter,
  STORY_TEAM_CATALOG_LOOKUPS,
} from "./storyCatalogCharacters";
import { STORY_ACCURACY_TOTAL_CAP } from "./storyTeamRules";

const STORY_BATTLE_CHARACTER_SOURCE = Object.freeze({
  STORY_HUMAN: "storyHuman",
  STORY_CREATURE: STORY_CREATURE_SOURCE,
  CATALOG: "catalog",
});

const STORY_HUMAN_CHARACTER_CARDS = Object.freeze([
  {
    id: "zay",
    name: "Zay",
    source: STORY_BATTLE_CHARACTER_SOURCE.STORY_HUMAN,
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/profile_images%2Fzay.png?alt=media&token=8012f800-8248-495f-835e-615b218dfab3",
    imageStart:"https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/avatars%2Fcharacter_ip_0008_zay-start.png?alt=media&token=2bbc4518-a98a-4091-8c67-3748d4cff53c",
    imageFin:"https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/avatars%2Fcharacter_ip_0007_zay-fin.png?alt=media&token=568a6e0d-3df7-4d36-bd49-ea73ba1c1594",
    imageHit:"https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/avatars%2Fcharacter_ip_0006_zay-hit.png?alt=media&token=3939f26a-d0c6-4f82-be22-4d58ff90840e",
      spriteKey: "zay",
    portrait:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/profile_images%2Fzay.png?alt=media&token=8012f800-8248-495f-835e-615b218dfab3",
    rarity: "Common",
    element: "air",
    attackName: "Gale Breaker",
    bgColor1: "#2b57ff",
    bgColor2: "#7fdcff",
    stats: {
      health: 6,
      attack: 2,
      defense: 4,
      accuracy: 6,
    },
    flavor: {
      role: "Story Leader",
      description:
        "A balanced frontline leader who keeps pressure on the enemy without giving up control of the field.",
    },
  },
  {
    id: "kolby",
    name: "Kolby",
    source: STORY_BATTLE_CHARACTER_SOURCE.STORY_HUMAN,
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/profile_images%2Fkolby.png?alt=media&token=f99d8d05-cdd0-4991-90ea-51f943764255",
    imageStart:"https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/avatars%2Fcharacter_ip_0005_Kolby-start.png?alt=media&token=f8fadf7e-af33-4d26-a271-b55191e5da69",
    imageFin:"https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/avatars%2Fcharacter_ip_0004_Kolby-fin.png?alt=media&token=e444e857-202d-4e9d-a887-e244422d2bf1",
    imageHit:"https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/avatars%2Fcharacter_ip_0003_Kolby-hit.png?alt=media&token=ef1db3ca-a8c9-4f1c-8433-1a14f0adacbc",
      spriteKey: "kolby",
    portrait:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/profile_images%2Fkolby.png?alt=media&token=f99d8d05-cdd0-4991-90ea-51f943764255",
    rarity: "Common",
    element: "rock",
    attackName: "Boulder Rush",
    bgColor1: "#7b6652",
    bgColor2: "#c3ab8b",
    stats: {
      health: 7,
      attack: 3,
      defense: 4,
      accuracy: 4,
    },
    flavor: {
      role: "Story Tank",
      description:
        "A durable protector built to absorb pressure and hold the line while the rest of the team sets up.",
    },
  },
  {
    id: "yuna",
    name: "Yuna",
    source: STORY_BATTLE_CHARACTER_SOURCE.STORY_HUMAN,
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/profile_images%2Fyuna.png?alt=media&token=e0aac6dd-5d30-4eb0-8de7-3d894fbf9d37",
    imageStart:"https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/avatars%2Fcharacter_ip_0002_Yuna-start.png?alt=media&token=32c3e069-e610-4ac8-9e74-7d7fbc29c7ed",
    imageFin:"https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/avatars%2Fcharacter_ip_0001_Yuna-fin.png?alt=media&token=254d1b78-3b25-446e-a5cf-ac1a6cb3e96d",
    imageHit:"https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/avatars%2Fcharacter_ip_0000_Yuna-hit.png?alt=media&token=7dc73f67-f38c-4ebb-a296-fde04024781e",
      spriteKey: "yuna",
    portrait:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/profile_images%2Fyuna.png?alt=media&token=e0aac6dd-5d30-4eb0-8de7-3d894fbf9d37",
    rarity: "Common",
    element: "electric",
    attackName: "Static Thread",
    bgColor1: "#7b63ff",
    bgColor2: "#f29dff",
    stats: {
      health: 8,
      attack: 2,
      defense: 2,
      accuracy: 6,
    },
    flavor: {
      role: "Story Striker",
      description:
        "An evasive attacker with precise follow-through who shines when the team creates openings for her.",
    },
  },
  {
    id: "infinity-orb",
    name: "Infinity Orb",
    source: STORY_BATTLE_CHARACTER_SOURCE.STORY_HUMAN,
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/avatars%2Fio-start.png?alt=media&token=9c04273c-0eeb-4498-b703-64ef2e7fb923",
    imageStart:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/avatars%2Fio-start.png?alt=media&token=9c04273c-0eeb-4498-b703-64ef2e7fb923",
    imageFin:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/avatars%2Fio-fin.png?alt=media&token=97eabc33-2d27-4e36-9f24-cf41afaed32b",
    imageHit:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/avatars%2Fio-hit.png?alt=media&token=5d0686ea-cd9d-408f-89ba-5e70789b0fd8",
    spriteKey: "infinity_orb",
    portrait:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/avatars%2Fio-start.png?alt=media&token=9c04273c-0eeb-4498-b703-64ef2e7fb923",
    rarity: "Common",
    element: "electric",
    attackName: "Small Zap",
    bgColor1: "#2f73ff",
    bgColor2: "#7ef6ff",
    stats: {
      health: 5,
      attack: 2,
      defense: 2,
      accuracy: 5,
    },
    flavor: {
      role: "Story Disruptor",
      description:
        "A charged training drone that tests spacing, timing, and whether a team can stay calm under constant pressure.",
    },
  },
]);

const normalizeBattleStat = (value) => {
  const nextValue = Number(value ?? 0);
  return Number.isFinite(nextValue) ? nextValue : 0;
};

const normalizeStoryBoostKey = (value = "") =>
  String(value || "")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

const getBoostsForStoryKey = (storyCharacterBoosts = {}, storyKey = "") => {
  const normalizedKey = normalizeStoryBoostKey(storyKey);
  const boosts = storyCharacterBoosts?.[normalizedKey] || {};

  return STORY_BOOST_STAT_KEYS.reduce((acc, statKey) => {
    acc[statKey] = Math.max(
      0,
      Math.floor(Number(boosts?.[statKey] || DEFAULT_STORY_CHARACTER_BOOSTS[statKey])),
    );
    return acc;
  }, {});
};

const getBoostTotal = (boosts = {}) =>
  STORY_BOOST_STAT_KEYS.reduce(
    (total, statKey) => total + Number(boosts?.[statKey] || 0),
    0,
  );

const applyStoryBoostsToBattleCharacter = (
  character,
  storyKey,
  storyCharacterBoosts = {},
) => {
  if (!character) return character;

  const boosts = getBoostsForStoryKey(storyCharacterBoosts, storyKey);
  const appliedBoosts = {
    ...boosts,
    accuracy: Math.min(
      boosts.accuracy,
      Math.max(
        0,
        STORY_ACCURACY_TOTAL_CAP - Number(character.accuracy || 0),
      ),
    ),
  };
  if (getBoostTotal(appliedBoosts) <= 0) return character;

  const baseBoosts = character.boosts || DEFAULT_STORY_CHARACTER_BOOSTS;
  const combinedBoosts = STORY_BOOST_STAT_KEYS.reduce((acc, statKey) => {
    acc[statKey] =
      Number(baseBoosts?.[statKey] || 0) +
      Number(appliedBoosts[statKey] || 0);
    return acc;
  }, {});

  return {
    ...character,
    health: Number(character.health || 0) + appliedBoosts.health,
    attack: Number(character.attack || 0) + appliedBoosts.attack,
    defense: Number(character.defense || 0) + appliedBoosts.defense,
    accuracy: Number(character.accuracy || 0) + appliedBoosts.accuracy,
    boosts: combinedBoosts,
  };
};

const applyRoleStatOverrides = (character, statOverrides = null) => {
  if (!character || !statOverrides || typeof statOverrides !== "object") {
    return character;
  }

  const health = normalizeBattleStat(
    statOverrides.health ?? character.startingHealth ?? character.health,
  );
  const attack = normalizeBattleStat(
    statOverrides.attack ?? character.startingAttack ?? character.attack,
  );
  const defense = normalizeBattleStat(
    statOverrides.defense ?? character.startingDefense ?? character.defense,
  );
  const accuracy = normalizeBattleStat(
    statOverrides.accuracy ?? character.startingAccuracy ?? character.accuracy,
  );

  return {
    ...character,
    health,
    attack,
    defense,
    accuracy,
    startingHealth: health,
    startingAttack: attack,
    startingDefense: defense,
    startingAccuracy: accuracy,
  };
};

export const STORY_BATTLE_ROLE_FIELDS = Object.freeze({
  SOURCE: "source",
  CHARACTER_ID: "characterId",
  ALIAS: "alias",
});

export const STORY_BATTLE_ROLE_SOURCE = STORY_BATTLE_CHARACTER_SOURCE;

export const getStoryHumanCharacterCard = (characterId) =>
  STORY_HUMAN_CHARACTER_CARDS.find(
    (character) => character.id === String(characterId || "").toLowerCase(),
  ) || null;

export const buildStoryTeamBattleRole = (characterKey = "") => {
  const normalizedKey = String(characterKey || "zay").trim().toLowerCase() || "zay";

  if (getStoryHumanCharacterCard(normalizedKey)) {
    return {
      source: STORY_BATTLE_CHARACTER_SOURCE.STORY_HUMAN,
      characterId: normalizedKey,
    };
  }

  return {
    source: STORY_BATTLE_CHARACTER_SOURCE.CATALOG,
    characterId: STORY_TEAM_CATALOG_LOOKUPS[normalizedKey]?.[0] || normalizedKey,
    alias: normalizedKey,
  };
};

// Story battle characters should be fully match-ready without relying on
// account-owned Character cards or collectible-catalog state.
export const buildStoryBattleCharacter = (storyCharacter = null) => {
  if (!storyCharacter?.id) return null;

  const health = normalizeBattleStat(storyCharacter?.stats?.health);
  const attack = normalizeBattleStat(storyCharacter?.stats?.attack);
  const defense = normalizeBattleStat(storyCharacter?.stats?.defense);
  const accuracy = normalizeBattleStat(storyCharacter?.stats?.accuracy);

  return {
    id: storyCharacter.id,
    source: STORY_BATTLE_CHARACTER_SOURCE.STORY_HUMAN,
    name: storyCharacter.name || "Story Human",
    imageUrl: storyCharacter.imageUrl || "",
    imageStart: storyCharacter.imageStart || "",
    imageFin: storyCharacter.imageFin || "",
    imageHit: storyCharacter.imageHit || "",
    spriteKey: storyCharacter.spriteKey || null,
    portrait: storyCharacter.portrait || storyCharacter.imageUrl || "",
    rarity: storyCharacter.rarity || "Common",
    element: storyCharacter.element || null,
    attackName: storyCharacter.attackName || "Strike",
    bgColor1: storyCharacter.bgColor1 || "#ffffff",
    bgColor2: storyCharacter.bgColor2 || "#ffffff",
    health,
    attack,
    defense,
    accuracy,
    startingHealth: health,
    startingAttack: attack,
    startingDefense: defense,
    startingAccuracy: accuracy,
    stance: "defense",
    isDead: false,
    buffs: {
      attack: [],
      defense: [],
      health: [],
      accuracy: [],
    },
    flavor: storyCharacter.flavor || null,
  };
};

const buildCatalogBattleCharacter = (catalogCharacter = null, role = {}) => {
  if (!catalogCharacter?.id) return null;

  const health = normalizeBattleStat(
    catalogCharacter.startingHealth ?? catalogCharacter.health,
  );
  const attack = normalizeBattleStat(
    catalogCharacter.startingAttack ?? catalogCharacter.attack,
  );
  const defense = normalizeBattleStat(
    catalogCharacter.startingDefense ?? catalogCharacter.defense,
  );
  const accuracy = normalizeBattleStat(
    catalogCharacter.startingAccuracy ?? catalogCharacter.accuracy,
  );

  return {
    ...catalogCharacter,
    source: STORY_BATTLE_CHARACTER_SOURCE.CATALOG,
    alias: role.alias || null,
    health,
    attack,
    defense,
    accuracy,
    startingHealth: health,
    startingAttack: attack,
    startingDefense: defense,
    startingAccuracy: accuracy,
    stance: catalogCharacter.stance || "defense",
    isDead: Boolean(catalogCharacter.isDead),
    buffs: {
      attack: Array.isArray(catalogCharacter?.buffs?.attack)
        ? [...catalogCharacter.buffs.attack]
        : [],
      defense: Array.isArray(catalogCharacter?.buffs?.defense)
        ? [...catalogCharacter.buffs.defense]
        : [],
      health: Array.isArray(catalogCharacter?.buffs?.health)
        ? [...catalogCharacter.buffs.health]
        : [],
      accuracy: Array.isArray(catalogCharacter?.buffs?.accuracy)
        ? [...catalogCharacter.buffs.accuracy]
        : [],
    },
  };
};

// Source-aware role resolution lets future Story battles mix repo-owned humans
// like Zay with existing collectible/catalog characters like Toshi.
export const resolveStoryBattleCharacterRole = (
  role = null,
  { catalogCharacters = [], storyCharacterBoosts = {} } = {},
) => {
  if (!role?.source || !role?.characterId) return null;

  if (role.source === STORY_BATTLE_CHARACTER_SOURCE.STORY_HUMAN) {
    return applyRoleStatOverrides(
      applyStoryBoostsToBattleCharacter(
        buildStoryBattleCharacter(getStoryHumanCharacterCard(role.characterId)),
        role.characterId,
        storyCharacterBoosts,
      ),
      role.statOverrides,
    );
  }

  if (role.source === STORY_BATTLE_CHARACTER_SOURCE.CATALOG) {
    const catalogCharacter =
      (catalogCharacters || []).find(
        (character) => String(character?.id || "") === String(role.characterId || ""),
      ) ||
      resolveStoryTeammateCatalogCharacter(
        role.alias || role.characterId,
        catalogCharacters,
      );

    return applyRoleStatOverrides(
      applyStoryBoostsToBattleCharacter(
        buildCatalogBattleCharacter(catalogCharacter, role),
        role.alias || role.characterId,
        storyCharacterBoosts,
      ),
      role.statOverrides,
    );
  }

  if (role.source === STORY_BATTLE_CHARACTER_SOURCE.STORY_CREATURE) {
    return applyRoleStatOverrides(
      buildStoryCreatureBattleCharacter(getStoryCreatureCard(role.characterId)),
      role.statOverrides,
    );
  }

  return null;
};

export { STORY_HUMAN_CHARACTER_CARDS };
